import { Link } from 'react-router-dom';
import TopBar from '@/components/feature/TopBar';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';

interface LegalPageLayoutProps {
  title: string;
  children: React.ReactNode;
}

export default function LegalPageLayout({ title, children }: LegalPageLayoutProps) {
  return (
    <div className="min-h-screen bg-background-50">
      <TopBar />
      <Navbar />
      <main>
        <section className="py-12 md:py-16 bg-secondary-800">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <h1 className="font-heading text-2xl md:text-4xl text-background-50">{title}</h1>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="prose prose-sm md:prose-base max-w-none text-foreground-600 leading-relaxed">
              {children}
            </div>
            <div className="mt-12 p-4 bg-background-100 rounded-lg border border-background-200/70">
              <p className="text-xs text-foreground-500">
                <strong className="text-foreground-700">Not:</strong> Bu sayfadaki metinler örnek/placeholder içeriktir. Yasal geçerlilik için bir hukuk danışmanı tarafından kontrol edilmesi ve firmanıza özel olarak düzenlenmesi gerekmektedir.
              </p>
            </div>
            <div className="mt-8 flex justify-center">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-primary-600 text-sm hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
                Ana Sayfaya Dön
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}